<template>
  <course-tutor-main/>
</template>

<script>
import CourseTutorMain from "@/components/CourseTutorMain";
import {getUrlVars} from "@/ezRouter";

export default {
  name: 'App',
  components: {
    CourseTutorMain
  },
  created() {
    this.$store.commit('loadCourses')
    this.$store.commit('loadDiscuss')
    let params = getUrlVars()
    console.log("Read params:", params)
    if(params.importCoursesID){
      this.$notify({
        title: '已載入課程!',
        message: '在這個人的課程表上塗鴉囉～',
        type: 'success'
      });
      this.$store.commit('loadSharedCourses', params)
    }
    if(params.code){
      this.$notify({
        title: '你現在已登入為' + params.username,
        message:  '點右上角的頭像修改科系和年級吧！\n（NCTUOauth未開放給本NCTU查科系的權限，需要手動填寫 (T⌓T)））',
        type: 'success'
      });
      this.$store.commit('signLoginUser',params)
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
  height: 100%
}
</style>
